module.exports = __webpack_public_path__ + "static/media/1.a741d734.jpg";